import React from 'react';
import propTypes from 'prop-types';

export const AdultIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      // style="enable-background:new 0 0 512 512;"
      xmlSpace="preserve"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
    >
      <g>
        <g>
          <g>
            <path
              d="M256,106.667c29.461,0,53.333-23.872,53.333-53.333C309.333,23.872,285.461,0,256,0
				c-29.461,0-53.333,23.872-53.333,53.333C202.667,82.795,226.539,106.667,256,106.667z"
            />
            <path
              d="M298.667,128h-85.333C183.936,128,160,151.936,160,181.333v128c0,17.643,14.357,32,32,32
				c3.733,0,7.339-0.64,10.667-1.813V480c0,17.643,14.357,32,32,32c8.192,0,15.659-3.093,21.333-8.171
				c5.675,5.077,13.141,8.171,21.333,8.171c17.643,0,32-14.357,32-32V339.52c3.328,1.173,6.933,1.813,10.667,1.813
				c17.643,0,32-14.357,32-32v-128C352,151.936,328.064,128,298.667,128z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
AdultIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
  stroke: propTypes.string,
};
AdultIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
  stroke: 'black',
};
